import request from '@/utils/request';

/**
 * 查询员工积分明细列表
 */
export function listApi(params) {
  return request({
    url: "/admin/customers/emp/integral/list",
    method: 'GET',
    params: params
  });
}

/**
 * 获取客户
 */
export function activeCustomersApi() {
  return request({
    url: "/admin/customers/active-customers",
    method: 'GET'
  });
}